import { useEffect } from 'react';
import { getPublishedExperienceCardsForExport, getTarifariosForCatalogExport, getTarifariosTransporteForExport, getPublishedExperiences, getCidadeById, getTarifarioGlobalConfig, getCidades } from '../lib/experienciasStorage';

const MESSAGE_TYPE = 'naviex-experiencias-export';

/**
 * Página pública (sem login) usada pelo cliente em iframe para obter as experiências
 * publicadas (catálogo) e tarifários quando cliente e admin rodam em origens diferentes.
 * Inclui experienciasCompletas para a página de detalhes (ExperienceDetails) funcionar ao clicar no info.
 * Enriquece cada experiência com locationEstado e locationPais para exibir "Cidade, Estado, País".
 */
export default function ExperienciasExportPage() {
  useEffect(() => {
    try {
      const cards = getPublishedExperienceCardsForExport();
      const tarifarios = getTarifariosForCatalogExport();
      const published = getPublishedExperiences();
      const experienciasCompletas = published.map((e) => {
        const city = e.cidadeId ? getCidadeById(e.cidadeId) : null;
        return {
          ...e,
          locationEstado: city?.estadoProvincia?.trim() || undefined,
          locationPais: city?.pais?.trim() || undefined,
        };
      });
      const tarifarioGlobal = getTarifarioGlobalConfig();
      const tarifariosTransporte = getTarifariosTransporteForExport();
      const cidades = getCidades().map((c) => ({
        id: c.id,
        cidade: c.cidade,
        estadoProvincia: c.estadoProvincia,
        regioes: c.regioes ?? [],
        pais: c.pais,
        cep: c.cep,
        fotos: c.fotos,
        fotoPrincipalIndex: c.fotoPrincipalIndex,
        transportOpcoes: c.transportOpcoes,
      }));
      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, experiencias: cards, tarifarios, tarifariosTransporte, experienciasCompletas, tarifarioGlobal, cidades }, '*');
      }
    } catch (err) {
      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, experiencias: [], tarifarios: [], tarifariosTransporte: {}, experienciasCompletas: [], tarifarioGlobal: null, cidades: [], error: String(err) }, '*');
      }
    }
  }, []);

  return (
    <div className="p-4 text-sm text-gray-500">
      Catálogo enviado ao cliente.
    </div>
  );
}
